export default __webpack_public_path__ + "static/media/fpx-logo.5d61edf4.svg";